module.exports = __webpack_public_path__ + "static/img/square-chechmark-outline.c815032c.svg";